import { useContext } from "react";
import { UIContextType, UIContext } from "../contexts/uiContext";

export const useUI = (): UIContextType => useContext(UIContext);
